import { createSlice } from '@reduxjs/toolkit';

const areaSlice = createSlice({
  name: 'area',
  initialState: {
    areas: [],
    loading: false,
    error: null,
  },
  reducers: {
    setAreas: (state, action) => {
      state.areas = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setAreas, setLoading, setError } = areaSlice.actions;
export default areaSlice.reducer;
